<script setup>
import { RouterView } from 'vue-router'
import Info from '@/components/icons/Info.vue'
import { computed } from 'vue'

const version = computed(() => import.meta.env.VITE_APP_VERSION)
</script>

<template>
  <v-layout>
    <v-app full-height>
      <v-app-bar>
        <v-app-bar-title>
          Pokerabi
          <a href="https://en.wikipedia.org/wiki/Hammurabi" target="_blank">
            <info />
          </a>
          <div class="float-right mr-4">v{{ version }}</div>
        </v-app-bar-title>
      </v-app-bar>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </v-layout>
</template>

<style scoped></style>
